import { Row, Col, Button, Form } from 'react-bootstrap';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ProspectSearch.css';
import { formatRut, checkRut } from "react-rut-formatter";
import { patientExistError, missingConsentError } from 'hooks/selfEnrollment/errorConstans';
import AlertDialog from 'components/Alerts/AlertDialog';

const ProspectSearch = ({handleSearch, prospectExists, missingConsent, handleProspectExists, handleMissingConsent, handleCloseAlert }) => {
  const [dni, setDni] = React.useState('');
  const [isDniValid, setIsDniValid] = React.useState(false);

  const handleChange = (e) => {
    const value = e.target.value;
    setDni(formatRut(value));
    setIsDniValid(checkRut(value));
  }

  const handleSearchDni = () => {
    handleSearch(dni);
    setDni('');
  }

  return (
    <Row className='welcome-container'>
      <Col className='text-start'>
        <h2>Ingresa tu RUT</h2>
        <Form>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Control 
            type="text" 
            placeholder="12345678-9"
            value={dni}
            onChange={handleChange}
            />
          </Form.Group>
          <div className="register-footer-row">
            <Button 
              variant='primary'
              disabled={!isDniValid}
              onClick={handleSearchDni}
            >Verificar</Button>
          </div>
        </Form>
      </Col>
      <AlertDialog
        show={prospectExists}
        title={patientExistError.title}
        bodyMessage={patientExistError.message}
        buttonName={patientExistError.buttonName}
        buttonFunction={() => { handleProspectExists(false) }}
        onHide={() => { handleCloseAlert() }}
      />
      <AlertDialog
        show={missingConsent}
        title={missingConsentError.title}
        bodyMessage={missingConsentError.message}
        buttonName={missingConsentError.buttonName}
        buttonFunction={() => { handleMissingConsent() }}
        onHide={() => { handleCloseAlert() }}
      />
    </Row>
  );
};

export default ProspectSearch;
    